module.exports = __webpack_public_path__ + "static/media/AccountLogout.efc24b3b.svg";